// @ts-nocheck
// Toast global — substituir window.alert em pontos críticos.
//
// Uso:
//   import { toast } from './toast';
//   toast.success('Salvo');
//   toast.error('Falhou');
//   toast.info('Recarregando…');
//
// Toaster (componente) deve ser montado uma vez no App.tsx.
import React, { useEffect, useState } from 'react';

type ToastType = 'success' | 'error' | 'info';
interface ToastItem {
  id: number;
  type: ToastType;
  message: string;
  expiresAt: number;
}

let nextId = 1;
let listeners: Array<(items: ToastItem[]) => void> = [];
let items: ToastItem[] = [];

function notify() {
  for (const fn of listeners) fn(items);
}

function push(type: ToastType, message: string, durationMs = 3500) {
  const id = nextId++;
  const item: ToastItem = { id, type, message, expiresAt: Date.now() + durationMs };
  items = [...items, item];
  notify();
  setTimeout(() => {
    items = items.filter(x => x.id !== id);
    notify();
  }, durationMs);
}

export const toast = {
  success: (msg: string) => push('success', msg, 3000),
  error: (msg: string) => push('error', msg, 4500),
  info: (msg: string) => push('info', msg, 3000),
};

export const Toaster: React.FC = () => {
  const [list, setList] = useState<ToastItem[]>(items);
  useEffect(() => {
    const fn = (next: ToastItem[]) => setList([...next]);
    listeners.push(fn);
    return () => { listeners = listeners.filter(x => x !== fn); };
  }, []);
  if (list.length === 0) return null;
  return (
    <div style={{
      position: 'fixed', top: 16, left: '50%', transform: 'translateX(-50%)',
      zIndex: 1000, display: 'flex', flexDirection: 'column', gap: 8,
      width: 'min(92vw, 460px)', pointerEvents: 'none',
    }}>
      {list.map(t => (
        <div key={t.id} style={{
          padding: '12px 16px', borderRadius: 12,
          background: t.type === 'success' ? 'rgba(74,138,90,0.96)'
                    : t.type === 'error'   ? 'rgba(192,58,42,0.96)'
                    : 'rgba(20,16,14,0.92)',
          color: '#F5F1EA',
          fontSize: 13.5, lineHeight: 1.4,
          boxShadow: '0 14px 32px -10px rgba(0,0,0,0.35)',
          backdropFilter: 'blur(8px)',
          animation: 'tslide 220ms ease-out',
          pointerEvents: 'auto',
          display: 'flex', alignItems: 'center', gap: 10,
        }}>
          <span style={{ fontSize: 16, lineHeight: 1 }}>
            {t.type === 'success' ? '✓' : t.type === 'error' ? '✕' : 'ℹ'}
          </span>
          <span style={{ flex: 1 }}>{t.message}</span>
        </div>
      ))}
      <style>{`@keyframes tslide { from { opacity:0; transform:translateY(-8px) } to { opacity:1; transform:translateY(0) } }`}</style>
    </div>
  );
};
